import React from "react";
import PrintField from "../../shared/PrintField";
import "./NoticeofCapitalReduction.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

// ฟอร์มประกาศเลิกบริษัท (ครั้งที่ 2)
const NoticeofCapitalReduction = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      <div className="inv-paper" ref={ref}>
        <h2 className="nd-title">ประกาศลดทุน</h2>

        {/* ชื่อบริษัท จัดกึ่งกลาง */}
        <div className="nd-center-line inv-bold">
          บริษัท
          <InputField className="nd-input long" />
          จำกัด
        </div>

        {/* พารากราฟ 1: ย่อหน้า */}
        <p className="nd-paragraph">
          ด้วยที่ประชุมผู้ถือหุ้น ของบริษัท
          <InputField className="nd-input long" />
          จำกัด ได้มีมติพิเศษเมื่อวันที่
          <InputField className="nd-input date" />
          ให้ลดทุนของบริษัทจากเดิม
          <InputField className="nd-input date" />
          แบ่งออกเป็น
          <InputField className="nd-input date" />
          มูลค่าหุ้นละหนึ่งร้อยบาท (100) ลงมาคงเหลือ
          {/* capital after the reduction: was printed as a fixed "ห้าแสนบาท (500,000" for every company */}
          <InputField className="nd-input date" />
          แบ่งออกเป็น
          <InputField className="nd-input date" />มูลค่าหุ้นละหนึ่งร้อยบาท (100)
        </p>

        {/* พารากราฟ 2: ย่อหน้า */}
        <p className="nd-paragraph">
          ฉะนั้นหากผู้ใดจะคัดค้านการลดทุนนี้ ก็ขอให้ยื่นคำคัดค้านต่อบริษัท ณ สำนักงานตั้งอยู่เลขที่
          <InputField className="nd-input long" />
          ภายในกำหนดสามสิบวัน นับแต่วันประกาศนี้เป็นต้นไป          
        </p>

        {/* วันที่ประกาศ */}
        <div className="nd-date-section">
          ประกาศ ณ วันที่
          <InputField className="nd-input date" />
        </div>

        <div className="inv-footer">            
            <div className="inv-sign-block">
              <InputField className="inv-sign-line" optional />
              ( <InputField className="inv-sign-name-field" printFit optional={false} /> )
              <div>กรรมการ</div>
            </div>
          </div>
      </div>
    </div>
  );
});

export default NoticeofCapitalReduction;
